import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { isEqualFormValues } from 'dpl/shared/form/utils';
import { COMMON_LABEL_CLASSES } from 'dpl/shared/form/utils/constants';

import ErrorWrapper from './ErrorWrapper';
import RadioButton from './RadioButton';

const TABS_VARIANTS = ['tabs', 'tabs-justified'];

export default function SimpleRadioButtonGroup({
  displayErrors,
  errors,
  label,
  name,
  onChange,
  options,
  value,
  inline,
  newDesignSystemStyles,
  variant,
  wrappedLastOption
}) {
  const isTabsVariant = TABS_VARIANTS.includes(variant);

  return (
    <div className="RadioButtonGroup">
      <ErrorWrapper isShown={displayErrors} errors={errors}>
        <fieldset>
          {label && (
            <legend
              className={classnames(
                'RadioButtonGroup__legend mb1',
                COMMON_LABEL_CLASSES
              )}
            >
              {label}
            </legend>
          )}
          <ul className="RadioButtonGroup__options">
            {options.map((o, idx) => (
              <li
                className={classnames({
                  mb1: !inline && !isTabsVariant,
                  'dib mr6': inline && !wrappedLastOption,
                  'dib mr6 mb4':
                    inline && wrappedLastOption && idx < options.length - 1,
                  'ph4 pv4 ba': isTabsVariant,
                  'b--default':
                    isTabsVariant && !isEqualFormValues(value, o.value),
                  'b--primary':
                    isTabsVariant && isEqualFormValues(value, o.value)
                })}
                key={o.value}
              >
                <RadioButton
                  checked={isEqualFormValues(value, o.value)}
                  id={`${name}-${o.value}`}
                  name={name}
                  onChange={onChange}
                  title={o.title}
                  subtitle={o.subtitle}
                  value={o.value}
                  variant={variant}
                  newDesignSystemStyles={newDesignSystemStyles}
                />
              </li>
            ))}
          </ul>
        </fieldset>
      </ErrorWrapper>
    </div>
  );
}

SimpleRadioButtonGroup.propTypes = {
  displayErrors: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.node),
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.bool
      ]).isRequired
    })
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  inline: PropTypes.bool,
  newDesignSystemStyles: PropTypes.bool,
  // Makes it so the last option is on its own line when inline is true
  wrappedLastOption: PropTypes.bool,
  variant: PropTypes.string
};

SimpleRadioButtonGroup.defaultProps = {
  displayErrors: false,
  errors: [],
  label: null,
  onChange: null,
  value: null,
  inline: false,
  newDesignSystemStyles: false,
  wrappedLastOption: false,
  variant: null
};
